<template>
    <div class="notifications-container">
        <div v-for="notification of getAllNotifications" :key="notification">
            <transition name="fade">
                <Notification :notification="notification" />
            </transition>
        </div>
    </div>
</template>

<script setup>
const notifications_store = useNotificationsStore()
const { getAllNotifications } = storeToRefs(notifications_store)
</script>

<style>
.notifications-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 975;
    overflow: hidden;
    margin: 0;
    padding: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
